<div class="date-picker">
  <div class="flex flex-col items-start">
    <div class="flex-1">
      <label *ngIf="label()" class="date-picker-label" [ngClass]="{
        'text-red': control?.invalid && (control?.dirty || control?.touched)
      }">{{ label() }}</label>
    </div>
    <div #inputGroup class="flex-1 input-group">
      <input
        type="text"
        [value]="displayValue || ''"
        (input)="onInput($event)"
        (blur)="onBlur()"
        [disabled]="control?.disabled"
      />

      <!-- (keydown)="onKeyDown($event)" -- this was an attribute on input but seems unnecessary -->

      <lib-icon (click)="togglePicker($event)" [icon]="'calendar'" class="icon"></lib-icon>
    </div>
    <p *ngIf="control?.hasError('required')" class="text-red">Required</p>
    <p *ngIf="control?.hasError('dateInPast')" class="text-red">Date cannot be in the past.</p>
    <p *ngIf="control?.hasError('dateTooFar')" class="text-red">Effective Date cannot be more than 60 days from today.</p>
  </div>
  <div #calendar class="calendar" *ngIf="showPicker">
    <div class="calendar-header">
      <span>{{ monthName }} {{ year }}</span>
      <div>
        <button (click)="previousMonth()" aria-label="Previous month">
          <lib-icon  [icon]="'chevron-left'" class="icon month-select"></lib-icon>
        </button>
        <button (click)="nextMonth()" aria-label="Next month">
           <lib-icon  [icon]="'chevron-right'" class="icon month-select"></lib-icon>
        </button>
      </div>
    </div>
    <div class="calendar-grid">
      <div class="day-header" *ngFor="let day of daysOfWeek">{{ day }}</div>
      <div
        *ngFor="let day of daysInMonth"
        [class]="day ? 'day' : 'empty'"
        [class.selected]="isSelected(day)"
        [class.disabled]="!isDateSelectable(day)"
        (click)="selectDate(day)"
      >
        {{ day || '' }}
      </div>
    </div>
  </div>
</div>